<template>
  <div class="container py-10">
    <div v-if="computedSubmissionDetails" class="flex flex-wrap -mx-10">
      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Company Information</h2>
        <edit-organization-info v-if="computedSubmissionDetails.revisedCompany" class="mb-3" :organization.sync="computedSubmissionDetails.revisedCompany" />
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Transaction Information</h2>
        <d-field label="Amount">
          <d-input v-model="computedAmount" type="number" />
        </d-field>
        <d-field label="Billing Company Name">
          <d-input v-model="computedTransactionDetails.companyName" />
        </d-field>
        <d-field label="Billing Address Line 1">
          <d-input v-model="computedTransactionDetails.billingAddress1" />
        </d-field>
        <d-field label="Billing Address Line 2">
          <d-input v-model="computedTransactionDetails.billingAddress2" />
        </d-field>
        <d-field label="Billing City">
          <d-input v-model="computedTransactionDetails.billingCity" />
        </d-field>
        <d-field label="Billing State/Province">
          <d-input v-model="computedTransactionDetails.billingStateProvince" />
        </d-field>
        <d-field label="Billing Zip">
          <d-input v-model="computedTransactionDetails.billingZip" />
        </d-field>
        <d-field label="Billing Email">
          <d-input v-model="computedTransactionDetails.billingEmail" type="email" />
        </d-field>
        <d-field label="Billing Phone">
          <d-input v-model="computedTransactionDetails.billingPhone" />
        </d-field>
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Additional Company Information</h2>
        <div class="mb-3">
          <d-field label="AWI Standards">
            <div>
              <div>
                <d-checkbox v-model="computedStandards" native-value="I currently own a copy of the AWI Quality Standards Illustrated, 8th Edition, Version 2">
                  I currently own a copy of the AWI Quality Standards Illustrated, 8th Edition, Version 2
                </d-checkbox>
              </div>
              <div>
                <d-checkbox v-model="computedStandards" native-value="I currently own a copy of the Architectural Woodwork Standards, Edition 1">
                  I currently own a copy of the Architectural Woodwork Standards, Edition 1
                </d-checkbox>
              </div>
              <div>
                <d-checkbox v-model="computedStandards" native-value="My company is currently an active AWI Member">
                  My company is currently an active AWI Member
                </d-checkbox>
              </div>
              <div>
                <d-checkbox v-model="computedStandards" native-value="Please send me AWI Membership information">
                  Please send me AWI Membership information
                </d-checkbox>
              </div>
            </div>
          </d-field>
          <d-field label="Years in Business">
            <d-input v-model="computedRevisedYearsInBusiness" type="number" required />
          </d-field>
          <d-field label="Total Sq. Footage">
            <d-input v-model="computedRevisedTotalSquareFootage" type="number" required />
          </d-field>
          <d-field label="Own or Lease Facility">
            <d-select v-model="computedSubmissionDetails.revisedOwnOrLeaseFacility" expanded>
              <option value="own">
                Own
              </option>
              <option value="lease">
                Lease
              </option>
            </d-select>
          </d-field>
          <d-field label="Own or Lease Equipment">
            <d-select v-model="computedSubmissionDetails.revisedOwnOrLeaseEquipment" expanded>
              <option value="own">
                Own
              </option>
              <option value="lease">
                Lease
              </option>
            </d-select>
          </d-field>
          <d-field label="# Installers">
            <d-input v-model="computedRevisedNumberOfInstallers" type="number" required />
          </d-field>
          <d-field label="# Employees in Office">
            <d-input v-model="computedRevisedNumberOfEmployeesInOffice" type="number" required />
          </d-field>
          <d-field label="# of Employees">
            <d-input v-model="computedRevisedNumberOfEmployees" type="number" required />
          </d-field>
          <d-field label="Annual Gross Sales">
            <d-input v-model="computedRevisedAnnualGrossSales" type="number" required />
          </d-field>
          <d-field label="Line of Business">
            <div>
              <div>
                <d-checkbox v-model="computedLineOfBusiness" native-value="Fabrication">
                  Fabrication
                </d-checkbox>
              </div>
              <div>
                <d-checkbox v-model="computedLineOfBusiness" native-value="Finishing">
                  Finishing
                </d-checkbox>
              </div>
              <div>
                <d-checkbox v-model="computedLineOfBusiness" native-value="Installation">
                  Installation
                </d-checkbox>
              </div>
            </div>
          </d-field>
        </div>
      </div>
      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Additional Company Information</h2>
        <div class="mb-3">
          <d-field label="Quality Grade">
            <d-select v-model="computedSubmissionDetails.revisedQualityGrade" expanded>
              <option value="Premium Grade and below">
                Premium Grade and below
              </option>
              <option value="Custom Grade only">
                Custom Grade only
              </option>
            </d-select>
          </d-field>
          <d-field label="License Type">
            <d-select v-model="computedSubmissionDetails.revisedLicenseType" expanded>
              <option value="Fabrication">
                Fabrication
              </option>
              <option value="Finishing">
                Finishing
              </option>
              <option value="Installation">
                Installation
              </option>
            </d-select>
          </d-field>
          <d-field label="How did you hear about the QCP?">
            <d-input v-model="computedSubmissionDetails.revisedHowDidYouHearAboutQCP" />
          </d-field>
          <d-field label="Join Reason">
            <d-input v-model="computedSubmissionDetails.revisedJoinReason" type="textarea" />
          </d-field>
          <d-field label="Current AWI Status Selected">
            <d-select v-model="computedSubmissionDetails.revisedAwiStatus" expanded>
              <option value="I am a current or would like to become an AWI Manufacturing/Industry Member">
                $2,000 - I am a current or would like to become an AWI Manufacturing/Industry Member
              </option>
              <option value="Non AWI Manufacturing/Industry QCP Application Fee">
                $3,500 - Non AWI Manufacturing/Industry QCP Application Fee
              </option>
            </d-select>
          </d-field>
          <d-field label="Business Summary">
            <d-input v-model="computedSubmissionDetails.revisedBusinessSummary" type="textarea" />
          </d-field>
          <d-field>
            <d-checkbox v-model="computedSubmissionDetails.revisedCompanyActivelySeeksAndConductsBusienss">
              This company actively seeks and conducts business with the general public (Policy Requirement)
            </d-checkbox>
          </d-field>
          <d-field>
            <d-checkbox v-model="computedSubmissionDetails.revisedRecentlyBidAProjectRequiringQCP">
              We have recently bid a project requiring QCP certification.
            </d-checkbox>
          </d-field>
          <d-field>
            <d-checkbox v-model="computedSubmissionDetails.revisedHaveBeenAwardedContractRequiringQCP">
              We have been awarded a contract for a project requiring QCP certification.
            </d-checkbox>
          </d-field>
        </div>
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Primary Contact Information</h2>
        <edit-contact-info v-if="computedSubmissionDetails.revisedPrimaryContact" class="mb-3" :contact.sync="computedSubmissionDetails.revisedPrimaryContact" />
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Principal Contact #1</h2>
        <edit-contact-info v-if="computedSubmissionDetails.revisedPrincipal1Contact" class="mb-3" :contact.sync="computedSubmissionDetails.revisedPrincipal1Contact" />
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Principal Contact #2</h2>
        <edit-contact-info v-if="computedSubmissionDetails.revisedPrincipal2Contact" class="mb-3" :contact.sync="computedSubmissionDetails.revisedPrincipal2Contact" />
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Project #1</h2>
        <edit-project-info v-if="computedSubmissionDetails.revisedProject1" class="mb-3" :project.sync="computedSubmissionDetails.revisedProject1" />
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Project #2</h2>
        <edit-project-info v-if="computedSubmissionDetails.revisedProject2" class="mb-3" :project.sync="computedSubmissionDetails.revisedProject2" />
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Project #3</h2>
        <edit-project-info v-if="computedSubmissionDetails.revisedProject3" class="mb-3" :project.sync="computedSubmissionDetails.revisedProject3" />
      </div>
    </div>
  </div>
</template>

<script>
  import EditOrganizationInfo from '@resources/scripts/patterns/formPatterns/EditOrganizationInfo.vue';
  import EditContactInfo from '@resources/scripts/patterns/formPatterns/EditContactInfo.vue';
  import EditProjectInfo from '@resources/scripts/patterns/formPatterns/EditProjectInfo.vue';

  export default {
    components: {
      EditOrganizationInfo,
      EditContactInfo,
      EditProjectInfo,
    },

    props: {
      submissionDetails: {
        type: Object,
        default: () => ({}),
      },

      transactionDetails: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      computedTransactionDetails: {
        get() {
          return this.transactionDetails;
        },
        set(value) {
          this.$emit('update:transactionDetails', value);
        },
      },

      computedAmount: {
        get() {
          return this.computedTransactionDetails.amount;
        },
        set(value) {
          this.computedTransactionDetails.amount = Number.parseInt(value, 10);
        },
      },

      computedSubmissionDetails: {
        get() {
          return this.submissionDetails;
        },
        set(value) {
          this.$emit('submissionDetails:update', value);
        },
      },

      computedLicensingSections: {
        get() {
          return JSON.parse(this.computedSubmissionDetails.revisedLicensingSections);
        },
        set(value) {
          this.computedSubmissionDetails.revisedLicensingSections = JSON.stringify(value);
        },
      },

      computedStandards: {
        get() {
          return JSON.parse(this.computedSubmissionDetails.revisedStandards);
        },
        set(value) {
          this.computedSubmissionDetails.revisedStandards = JSON.stringify(value);
        },
      },

      computedLineOfBusiness: {
        get() {
          return JSON.parse(this.computedSubmissionDetails.revisedLineOfBusiness);
        },
        set(value) {
          this.computedSubmissionDetails.revisedLineOfBusiness = JSON.stringify(value);
        },
      },

      computedRevisedYearsInBusiness: {
        get() {
          return this.computedSubmissionDetails.revisedYearsInBusiness;
        },
        set(value) {
          this.computedSubmissionDetails.revisedYearsInBusiness = Number.parseInt(value, 10);
        },
      },

      computedRevisedTotalSquareFootage: {
        get() {
          return this.computedSubmissionDetails.revisedTotalSquareFootage;
        },
        set(value) {
          this.computedSubmissionDetails.revisedTotalSquareFootage = Number.parseInt(value, 10);
        },
      },

      computedRevisedNumberOfInstallers: {
        get() {
          return this.computedSubmissionDetails.revisedNumberOfInstallers;
        },
        set(value) {
          this.computedSubmissionDetails.revisedNumberOfInstallers = Number.parseInt(value, 10);
        },
      },

      computedRevisedNumberOfEmployeesInOffice: {
        get() {
          return this.computedSubmissionDetails.revisedNumberOfEmployeesInOffice;
        },
        set(value) {
          this.computedSubmissionDetails.revisedNumberOfEmployeesInOffice = Number.parseInt(value, 10);
        },
      },

      computedRevisedNumberOfEmployees: {
        get() {
          return this.computedSubmissionDetails.revisedNumberOfEmployees;
        },
        set(value) {
          this.computedSubmissionDetails.revisedNumberOfEmployees = Number.parseInt(value, 10);
        },
      },

      computedRevisedAnnualGrossSales: {
        get() {
          return this.computedSubmissionDetails.revisedAnnualGrossSales;
        },
        set(value) {
          this.computedSubmissionDetails.revisedAnnualGrossSales = Number.parseInt(value, 10);
        },
      },
    },
  };
</script>